import { createContext, useContext } from 'react';
import type { LayoutRectangle } from 'react-native';

import type { SelectOption } from '@/components/ui/select/types';
import type { TextInputStatus } from '@/components/ui/text-input/types';

export type SelectContextValue = {
  disabled: boolean;
  open: boolean;
  setOpen: (next: boolean) => void;
  options: SelectOption[];
  selectedValue: string | null;
  setValue: (next: string) => void;
  closeOnSelect: boolean;
  placeholder: string;
  status: Exclude<TextInputStatus, 'disabled'>;
  triggerLayout: LayoutRectangle | null;
  setTriggerLayout: (next: LayoutRectangle | null) => void;
};

export const SelectContext = createContext<SelectContextValue | null>(null);

export function useSelectContext() {
  const ctx = useContext(SelectContext);
  if (!ctx) {
    throw new Error('Select.Trigger and Select.Content must be used within <Select>.');
  }
  return ctx;
}
